import api from '../../../../api';
import { AesDecrypt, AesEncrypt, keyPromise } from '../../../../Service/crypto';

export type BotFlowStatus = 'Active' | 'Draft' | 'Disabled';

export interface BotFlowRecord {
  id: string;
  bot_name: string;
  payer_domain: string;
  last_updated: string;
  classes: string[];
  classes_count: number;
  nodes_count: number;
  flow_status: BotFlowStatus;
}

export interface BotFlowAuditLog {
  id: string;
  Action: string;
  JsonData: any;
  UserName: string;
  Modified: string;
}

const encryptedPost = async <T,>(url: string, payload: unknown): Promise<T> => {
  const key = await keyPromise;
  const EncParams = await AesEncrypt(key, payload as any);
  const response = await api.fetch(url, {
    method: 'POST',
    body: JSON.stringify({ EncParams }),
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const raw = await response.json();
  return AesDecrypt(key, raw) as Promise<T>;
};

export const fetchBotFlows = async (): Promise<BotFlowRecord[]> => {
  const result = await encryptedPost<{ data?: BotFlowRecord[] } | string>('api/BotFlowManager/get-data', {});
  if (typeof result === 'string') {
    return [];
  }
  return Array.isArray(result.data) ? result.data : [];
};

export const addBotFlow = async (payload: {
  bot_name: string;
  payer_domain: string;
  classes: string[];
  flow_status: BotFlowStatus;
  UserId: string;
  Username: string;
}) => encryptedPost<{ success: boolean; message: string; id?: string }>('api/BotFlowManager/add-data', payload);

export const updateBotFlow = async (payload: {
  id: string;
  bot_name: string;
  payer_domain: string;
  classes: string[];
  flow_status: BotFlowStatus;
  UserId: string;
  Username: string;
  Before?: Record<string, any>;
  After?: Record<string, any>;
}) => encryptedPost<{ success: boolean; message: string }>('api/BotFlowManager/update-data', payload);

export const deleteBotFlow = async (payload: {
  id: string;
  bot_name: string;
  deletedBy: string;
  deletedById: string;
}) => encryptedPost<{ success: boolean; message: string }>('api/BotFlowManager/delete-data', payload);

export const fetchBotFlowAuditLog = async (id: string) => {
  const result = await encryptedPost<BotFlowAuditLog[]>('api/BotFlowManager/auditlog', { id });
  return Array.isArray(result) ? result : [];
};
